export const template = `
<ng-content></ng-content>
`;
